import { licenseApi } from "../../../../api/apiClient";

function getChangeRequests() {
  return licenseApi.get(`/admin/license-requests`);
}

function acceptChangeRequest(id) {
  return licenseApi.post(`/admin/license-requests/accept/${id}`);
}
function deleteChangeRequest(id) {
  return licenseApi.post(`/admin/license-requests/delete/${id}`);
}
export const changeRequestsServices = {
  getChangeRequests,
  acceptChangeRequest,
  deleteChangeRequest
};
